import { render, staticRenderFns } from "./sales-details.vue?vue&type=template&id=2390aa04&scoped=true&"
import script from "./sales-details.vue?vue&type=script&lang=js&"
export * from "./sales-details.vue?vue&type=script&lang=js&"
import style0 from "./sales-details.vue?vue&type=style&index=0&id=2390aa04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2390aa04",
  null
  
)

export default component.exports